import { render, staticRenderFns } from "./adminConfig.vue?vue&type=template&id=6672215a&scoped=true&"
import script from "./adminConfig.vue?vue&type=script&lang=js&"
export * from "./adminConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6672215a",
  null
  
)

export default component.exports